import ApiService from "./apiService";

/**
 * Created by Udara Prabath
 * Date: 10/29/2020
 * Using: IntelliJ IDEA
 */



export async function getAllLessons(classId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = 'student/public/lessons/'+ classId;
    return await ApiService.callApi(apiObject);
}



export async function enrollUsingSlip(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/enroll/deposit`;
    apiObject.body = {lessonId: body.lessonId,image:body.imageUrl};
    return await ApiService.callApi(apiObject);
}

export async function getVideoUrl(id,classId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/getVideo?contentId=${id}&classId=${classId}`;
    return await ApiService.callApi(apiObject);
}


export async function enrollUsingCard(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/enroll`;
    apiObject.body = {lessonId: body.lessonId};
    return await ApiService.callApi(apiObject);
}

export async function enrollClassPayment(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/enroll/payment`;
    apiObject.body = body;
    return await ApiService.callApi(apiObject);
}

export async function getEnrollLessons() {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/purchased`;
    return await ApiService.callApi(apiObject);
}

export async function getContentCount(id) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/viewCount/${id}`;
    return await ApiService.callApi(apiObject);
}

export async function getContentCountForSeparateLesson(id) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/viewCount/separate/${id}`;
    return await ApiService.callApi(apiObject);
}

export async function getVideoUrlForSeparateLesson(id,classId) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/lessons/getVideo/separate?contentId=${id}&classId=${classId}`;
    return await ApiService.callApi(apiObject);
}